import LoadState from '@/common/load-state';
import {useAuthState, useLoadUserInfo} from '@/store/auth-slice';
import React from 'react';
import MaskLoading from '@/component/mask-loading';
import './user-load.scss';

interface UserLoadProps {
    children?: React.ReactElement;
    loginHandler?: () => void;
}

const UserLoad: React.FC<UserLoadProps> = (props) => {
    const {children, loginHandler} = props;
    const {userLoadState, user} = useAuthState();
    const {clearUserInfo} = useLoadUserInfo();

    if (userLoadState === LoadState.INIT || userLoadState === LoadState.LOADING) {
        return <MaskLoading loading />;
    }
    if (loginHandler || userLoadState === LoadState.FAILED) {
        return (
            <div className="user-load-fail">
                <div className="tip">身份认证失败，请稍后重新尝试或登录</div>
                <button className="button" onClick={loginHandler || clearUserInfo}>
                    重新登录
                </button>
            </div>
        );
    }
    if (!user) {
        return null;
    }
    return children || null;
};

export default UserLoad;
